
export class EventType {
    id: number;
    eventTypeName: string;
    status: boolean;
}